var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-md-3 text-center text-md-left"},[_c('button',{staticClass:"cta",on:{"click":_vm.exportData}},[_vm._v("\n    exportar listado\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }